var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnconfirmedToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24Z",
    fill: "#B3BCD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2089 5C13.4626 5 14.4848 5.32788 15.2563 6.02222C16.0278 6.69728 16.4135 7.62307 16.4135 8.79959C16.4135 9.76395 16.1628 10.5547 15.6999 11.1719C15.5263 11.3648 14.967 11.8856 14.0412 12.6956C13.694 12.9849 13.4433 13.3128 13.2697 13.66C13.0768 14.0457 12.9804 14.4508 12.9804 14.9137V15.1837H10.7624V14.9137C10.7624 14.1807 10.8781 13.5443 11.1481 13.0235C11.3988 12.5027 12.151 11.6927 13.4047 10.574L13.6362 10.304C13.9833 9.87968 14.1569 9.41678 14.1569 8.9346C14.1569 8.29812 13.964 7.79665 13.6169 7.4302C13.2504 7.06374 12.7297 6.89015 12.0739 6.89015C11.2252 6.89015 10.6273 7.14089 10.2609 7.68093C9.933 8.12454 9.7787 8.76102 9.7787 9.57108H7.57996C7.57996 8.14382 7.98499 7.02516 8.83363 6.2151C9.66298 5.40503 10.7816 5 12.2089 5ZM11.8617 16.1288C12.286 16.1288 12.6525 16.2638 12.9418 16.5338C13.2118 16.8038 13.3661 17.151 13.3661 17.5753C13.3661 17.9996 13.2118 18.3661 12.9225 18.6361C12.6332 18.9061 12.286 19.0411 11.8617 19.0411C11.4374 19.0411 11.0902 18.8868 10.8009 18.6168C10.5116 18.3468 10.3766 17.9996 10.3766 17.5753C10.3766 17.151 10.5116 16.8038 10.8009 16.5338C11.0902 16.2638 11.4374 16.1288 11.8617 16.1288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnconfirmedToken);
export default __webpack_public_path__ + "static/media/unconfirmed-token.287f426e95b849c580867cab33c4405c.svg";
export { ForwardRef as ReactComponent };